module.exports = __webpack_public_path__ + "zvetseni-prsou_10_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_10_after.jpg
// module id = 1293
// module chunks = 0